import { TDeviceType } from '@cian/ui-kit/types';

const SLIDES_PER_VIEW_BY_DEVICE: Record<TDeviceType, number> = {
  phone: 1,
  tablet: 2,
  desktop: 3,
};

export const getSlidesPerView = (device: TDeviceType): number => {
  return SLIDES_PER_VIEW_BY_DEVICE[device];
};
